/**
 * 라인 선택 관련 핸들러 함수들
 */

/**
 * 라인 선택/해제 처리
 * @param {string} fileName - 파일 이름
 * @param {number} lineNumber - 라인 번호
 * @param {object} params - 필요한 상태 및 함수들
 */
export const handleLineClick = (fileName, lineNumber, params) => {
    const {
        step,
        activeFileName,
        setSelectedLines,
        updateLineDecorations
    } = params;

    setSelectedLines(prev => {
        // 배열이 아니면 빈 배열로 초기화
        if (!Array.isArray(prev)) {
            prev = [];
        }
        // 현재 파일의 선택된 라인 찾기
        const fileIndex = prev.findIndex(item => item.fileName === fileName);
        const currentLines = fileIndex !== -1 ? prev[fileIndex].lineNumbers : [];
        const isSelected = currentLines.includes(lineNumber);
        
        let newLines;
        if (isSelected) {
            // 이미 선택된 라인이면 해제
            newLines = currentLines.filter(ln => ln !== lineNumber);
        } else {
            // 선택되지 않은 라인이면 추가
            newLines = [...currentLines, lineNumber].sort((a, b) => a - b);
        }
        
        // 새로운 배열 생성
        let newSelectedLines;
        if (newLines.length > 0) {
            if (fileIndex !== -1) {
                // 기존 파일 업데이트
                newSelectedLines = [...prev];
                newSelectedLines[fileIndex] = { fileName: fileName, lineNumbers: newLines };
            } else {
                // 새 파일 추가
                newSelectedLines = [...prev, { fileName: fileName, lineNumbers: newLines }];
            }
        } else {
            // 라인이 없으면 해당 파일 제거
            newSelectedLines = prev.filter(item => item.fileName !== fileName);
        }
        
        // decoration 업데이트 (step1일 때만)
        if (step === 1 && fileName === activeFileName) {
            updateLineDecorations(fileName, newLines);
        }
        
        return newSelectedLines;
    });
};
